import { localForageSuriData } from '../Redux/UserDataRedux'
import { WEB_TYPES_KEYS } from '../Redux/SettingsRedux.js'
import { getSelectedQuote } from '../ContainerFunctions'

const CallBackMiddleware = ({ getState }) => next => (action) => {
  if (['ON_SELECT_QUOTE', 'ON_SET_REQUEST_ID', 'SET_SELECTED_QUOTES', 'REMOVE_QUOTE', 'ON_REMOVE_QUETE',
    'RESET_QUOTES', 'CONTRACT_REQUEST', 'CONTRACT_DRAFT_ACCEPT_REQUEST_SUCCESS', 'SET_GTM_PAGE_VIEW'].includes(action.type)) {

    const state = getState()
    if (state.appData.navigation.getIn(['lastValidStep', 'index']) === 4 && action.type === 'SET_GTM_PAGE_VIEW') {
      next(action)
      return
    }
    const selectedQuote = getSelectedQuote(
      state.appData.quote.getIn(['quoteRequests'], {}),
      state.appData.quote.getIn(['selectedQuotes'], {})
    )
    const webType = state.appData.settings.getIn(['webType'], 0)
    let deleteLocalForage = false
    let callBackData = {
      requestId: state.userData.previousRequestId,
      productName: state.appData.product.productName,
      website: WEB_TYPES_KEYS[webType],
      lastName: state.userData.getIn(['data', 'policyHolder', 'lastName'], ''),
      affiliate: state.appData.product.affiliate,
      quoteId: selectedQuote.id,
    }

    switch (action.type) {
      case 'ON_SELECT_QUOTE':
        callBackData.quoteId = action.quote.getIn(['id'], '')
        break
      case 'ON_SET_REQUEST_ID':
        callBackData.requestId = action.previousRequestId
        break
      case 'CONTRACT_REQUEST':
        if (state.appData.navigation.lastValidStep.index !== 4) {
          callBackData.contractId = state.appData.offer.getIn(['contractDraft', 'id'], '')
        } else {
          deleteLocalForage = true
        }
        break
      case 'CONTRACT_DRAFT_ACCEPT_REQUEST_SUCCESS':
        deleteLocalForage = true
        break
      case 'REMOVE_QUOTE':
      case 'ON_REMOVE_QUETE':
      case 'RESET_QUOTES':
        callBackData.quoteId = ''
        break
    }
    if (deleteLocalForage === false) {
      localForageSuriData.setItem('callBackData', JSON.stringify(callBackData))
    } else {
      localForageSuriData.removeItem('callBackData')
    }
  }

  next(action)
}

export default CallBackMiddleware
